import React from 'react';
import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';

/**
 * Pioneer Card — wraps MUI Card with project defaults.
 *
 * Defaults:
 * - variant="outlined" (Pioneer standard)
 *
 * All MUI Card props are supported and can override defaults.
 */
export interface CardProps extends MuiCardProps {}

const Card = React.forwardRef<React.ComponentRef<typeof MuiCard>, CardProps>(
  function Card(props, ref) {
    return <MuiCard variant="outlined" ref={ref} {...props} />;
  },
);

export default Card;
